import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
import { PageDefault } from '../pages/PageDefault';



@Injectable()
export class NewsService {
    constructor(
        private httpService: HttpService,
        private config: AppConfig) { }

    userName = this.config.getCurrentUser().UserName;

    // //发件箱
    // //chen 2017-01-10
    // outSend(input: InboxInput) {
    //     input.sendUserName = this.userName;
    //     let url = AppConfig.GetProdUrl() + "/Message/MessageForHy";
    //     let param = "userName=" + this.userName + "&pageSize=" + input.pageSize + "&pageIndex=" + input.pageIndex + "&typeCode=" + input.typeCode + "&levelCode=" + input.levelCode
    //         + "&stateCode=" + input.stateCode + "&sendUserName=" + input.sendUserName + "&receiveUserName=" + input.receiveUserName
    //         + "&startTime=" + input.startTime + "&endTime=" + input.endTime;
    //     return this.httpService.get(url + "?" + param);
    //     //userName: string, pageSize: Number, pageIndex: Number, typeCode: string, levelCode: string,stateCode: string, sendUserName: string, receiveUserName: string, startTime: string, endTime: string
    // }

    //收件箱
    //type 0收件列表 1发件列表
    //chen 2017-01-10
    //TQQ update 2017-02-23
    getNews(obj: InboxInput, type = 0) {
        if (type == 0) {
            obj.receiveUserName = this.userName;
        } else if (type == 1) {
            obj.sendUserName = this.userName;
        }
        let url = AppConfig.GetProdUrl() + "/Message/MessageForHy";
        let param = "userName=" + this.userName + "&pageSize=" + obj.pageSize + "&pageIndex=" + obj.pageIndex + "&typeCode=" + obj.typeCode + "&levelCode=" + obj.levelCode
            + "&stateCode=" + obj.stateCode + "&sendUserName=" + obj.sendUserName + "&receiveUserName=" + obj.receiveUserName + "&startTime=" + obj.startTime + "&endTime=" + obj.endTime;
        return this.httpService.get(url + "?" + param);
    }


    //发送消息
    //chen 2017-01-10
    sendNews(param) {
        let url = AppConfig.GetProdUrl() + "/Message/Send";
        return this.httpService.post(url, param);
    }

    //查询发消息级别(重要，紧急)
    //chen 2017-01-10
    getLevel(Code: string, Name: string) {
        let url = AppConfig.GetProdUrl() + "/Message/Type";
        let param = "Code=" + Code + "&Name=" + Name;
        return this.httpService.get(url + "?" + param);

    }


    //消息类别(上级消息，下级消息，系统消息)
    //chen 2017-01-10
    getMessageType(userName: string, messageType: string) {
        let url = AppConfig.GetProdUrl() + "/Message/Type";
        let param = "userName=" + userName + "&messageType=" + messageType;
        return this.httpService.get(url + "?" + param);
    }

    //标记已读
    //TQQ 2017-02-23
    read(Ids: string, username: string) {
        let url = AppConfig.GetProdUrl() + "/Message/Read";
        let param = { "UserName": username, "ListId": Ids };
        return this.httpService.post(url, param);
    }
    
    //获取用户直属下级列表
    //TQQ 2017-06-15
    getSubUserNames() {
        let url = AppConfig.GetProdUrl() + '/User/GetSubUserNames';
        return this.httpService.get(url);
    }



}

export class InboxInput {
    userName: string = "";
    pageSize: number = PageDefault.PageSize();
    pageIndex: number = PageDefault.PageIndex();
    typeCode: string = "_ALL";
    levelCode: string = "_ALL";
    stateCode: string = "_ALL";
    sendUserName: string = "";
    receiveUserName: string = "";
    startTime: string = PageDefault.startDate();
    endTime: string = PageDefault.endDate();

}





// WEBPACK FOOTER //
// ./src/services/news.service.ts